import { IUserProfile } from '../../models/IUserProfile';
import {
  UserImpersonationActions,
  UserImpersonationActionTypes,
} from '../action-types/userImpersonationActionTypes';

export interface IUserImpersonationState {
  allowedImpersonation: boolean;
  companyCode: string;
  allowedAva: boolean;
  alias: string;
  costCenter: string;
}

export const userImpersonationInitialState: IUserImpersonationState = {
  allowedImpersonation: false,
  companyCode: '',
  allowedAva: false,
  alias: '',
  costCenter: '',
};

export function userImpersonationReducer(
  prev: IUserImpersonationState = userImpersonationInitialState,
  action: UserImpersonationActions
): IUserImpersonationState {
  switch (action.type) {
    // case UserImpersonationActionTypes.REQUEST_IMPERSONATION: {
    //     return {
    //         ...prev,
    //     };
    // }
    // case UserImpersonationActionTypes.RECEIVE_IMPERSONATION: {
    //     return {
    //         ...prev,
    //         userProfile: action.userProfile,
    //     };
    // }
    case UserImpersonationActionTypes.SET_IMPERSONATION: {
      return {
        ...prev,
        allowedImpersonation: action.allowedImpersonation,
        companyCode: action.companyCode,
        allowedAva: action.allowedAva,
        alias: action.alias,
        costCenter: action.costCenter,
      };
    }
    default:
      return prev;
  }
}
